import type { FC, ReactNode } from "react";

export const TablePlaceholder: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={"text-center pb-6 pt-3 text-slate-500 text-sm"}>{children}</div>
);
